// Total lesson-step count per course, read straight from the lesson
// definitions, so "X of N" / completion percentages stay correct as lessons
// grow. Shared by the admin Team-progress and Manage-users screens.

import { LESSON_FOUNDATIONS } from "../data/lessons/foundations";
import { LESSON_COMMITS } from "../data/lessons/commits-branches";
import { LESSON_REMOTE } from "../data/lessons/remote";
import { LESSON_PULL_REQUESTS } from "../data/lessons/pull-requests";
import { LESSON_MERGE_CONFLICTS } from "../data/lessons/merge-conflicts";
import { LESSON_UNDOING } from "../data/lessons/undoing";

export const STEP_TOTALS: Record<string, number> = Object.fromEntries(
  [
    LESSON_FOUNDATIONS,
    LESSON_COMMITS,
    LESSON_REMOTE,
    LESSON_PULL_REQUESTS,
    LESSON_MERGE_CONFLICTS,
    LESSON_UNDOING,
  ].map((l) => [l.courseId, l.steps.length]),
);

interface ProgressShape {
  steps: Record<string, string[]>;
  quiz: Record<string, number>;
}

export function pct(done: number, total: number): number {
  if (!total) return 0;
  return Math.min(1, done / total);
}

/** Overall completion across every course with a built lesson, 0..1. */
export function overallPct(p: ProgressShape): number {
  let done = 0;
  let total = 0;
  for (const [courseId, count] of Object.entries(STEP_TOTALS)) {
    total += count;
    done += Math.min(count, p.steps[courseId]?.length ?? 0);
  }
  return pct(done, total);
}
